<div class="graphs">
  <div class="ui-g m-t-20">
    <div class="ui-g-7 m-t-10">
      <label>{{ 'DATA_PORTAL.CENSUS.DETAIL.TOTAL' | translate }}</label>
      <span class="m-r-5 number-value">{{graphsData.total}}</span>
      <wsd-delta [delta]="graphsData.delta"></wsd-delta>
    </div>
    <div class="ui-g-5">
      <div class="buttons-wrapper">
        <p-dropdown
          [options]="graphTypes"
          (onChange)="loadGraphs()"
          [(ngModel)]="selectedType">
        </p-dropdown>

        <p-dropdown
          class="m-l-5"
          [options]="graphYears"
          (onChange)="loadGraphs()"
          [(ngModel)]="selectedBarYear">
        </p-dropdown>
      </div>
    </div>
  </div>

  <div class="ui-g p-b-20">
    <div [ngClass]="{'ui-g-6': showDoughnut, 'ui-g-12': !showDoughnut}">
      <div class="ui-g-12" *ngIf="!showDoughnut">
        <div *ngFor="let entry of graphsData.barGraphData?.totalsDeltas">
          <div class="ui-g-4">
            <span class="number-value bar-chart-total-text inline">{{entry.total}}</span>
            <wsd-delta [delta]="entry.delta"></wsd-delta>
          </div>
        </div>
      </div>
      <div>
        <p-chart
          type="bar"
          [height]="'240px'"
          [data]="graphsData.barGraphData"
          [options]="getBarChartOptions"
          [plugins]="detailed ? chartDataLabelsPlugin.initialize({ chartType:'bar', textColor:'black', textSize:8 }) : [{}]">
        </p-chart>
        </div>
      </div>
      <div class="ui-g-6" *ngIf="showDoughnut">
        <p-chart
          type="doughnut"
          [data]="graphsData.donutBarData"
          [height]="'240px'"
          [options]="doughnutOptions"
          [plugins]="chartDataLabelsPlugin.initialize({ chartType:'pie', textColor:'black', textSize:8 })">
        </p-chart>
      </div>
    </div>

    <div class="ui-g" *ngIf="detailed">
      <div class="ui-g-offset-7 ui-g-5">
        <div class="buttons-wrapper">
          <p-dropdown
            [options]="getYearsWithoutCurrent"
            (onChange)="loadGraphs()"
            [(ngModel)]="selectedLineYear">
          </p-dropdown>
        </div>
      </div>
      <div class="ui-g-12 m-b-15">
        <label>
          {{ 'DATA_PORTAL.CENSUS.DETAIL.RETENTION_TRENDS' | translate }}
        </label>
        <p-chart
          type="line"
          [height]="'218px'"
          [data]="graphsData.lineGraphData"
          [options]="lineOptions">
        </p-chart>
      </div>
    </div>
  </div>
